import React from "react";

const AuthLayout = ({ children }) => {
  return (
    <div className="relative w-full min-h-screen overflow-x-auto z-auto bg-gray-50">
      <div className="min-h-screen flex flex-col">
        <div className="flex flex-1 overflow-y-auto flex-col">{children}</div>
      </div>
    </div>
  );
};

export default AuthLayout;
